import InventaireStocksMouvementController from './inventaire.stocks.mouvement.controller';
import Template from './inventaire.stocks.mouvement.html';

export default {
	bindings: {
		inventaire: '=',
		modalInstance: '='
	},
	controller: InventaireStocksMouvementController,
	template: Template
};
